export interface InventoryType {
  id: number;
  name: string | null;
  description: string | null;
  imageUrl: string | null;
  active: boolean | null;
  cost: number | null;

  // public virtual ICollection<Inventory> Inventories { get; set; } = new List<Inventory>();
}

export enum InventoryTypeEnum {
  Gasoline = 1,
  OnRoadClearDiesel = 2,
  OffRoadDyedDiesel = 3,
  DEF = 4,
}
